import React, { useState } from 'react';

export default function PinButton({ post, onToggle, loading, canPin, size = 14 }) {
  const [error, setError] = useState('');

  if (!canPin) return null;

  const isPinned  = !!(post.isPinned || post.pinned);
  const isLoading = loading === post.id;

  const handleClick = async (e) => {
    e.stopPropagation();
    if (isLoading) return;
    setError('');
    try {
      await onToggle(post);
    } catch (err) {
      setError('Failed');
      setTimeout(() => setError(''), 3000);
    }
  };

  return (
    <div style={{ position:'relative', display:'inline-flex' }}>
      <button
        onClick={handleClick}
        title={isPinned ? 'Remove from workbench' : 'Pin to workbench'}
        style={{
          background:  'none',
          border:      'none',
          cursor:      isLoading ? 'wait' : 'pointer',
          padding:     '4px',
          borderRadius: '5px',
          display:     'flex',
          alignItems:  'center',
          justifyContent: 'center',
          opacity:     isLoading ? 0.5 : 1,
          transition:  'all 0.15s',
          color:       isPinned ? '#fbbf24' : 'inherit',
          flexShrink:  0,
        }}
        onMouseEnter={e => { if (!isLoading) e.currentTarget.style.background = 'rgba(251,191,36,0.12)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'none'; }}
      >
        <svg
          width={size} height={size}
          viewBox="0 0 16 16"
          fill={isPinned ? '#fbbf24' : 'none'}
          stroke={isPinned ? '#fbbf24' : 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9.5 1.5 L14.5 6.5 L10 9 L10 13 L6 13 L6 9 L1.5 6.5 Z" />
          <line x1="8" y1="13" x2="8" y2="15.5" />
        </svg>
      </button>
      {error && (
        <div style={{
          position:'absolute', bottom:'-20px', left:'50%',
          transform:'translateX(-50%)',
          fontSize:'8px', color:'#f87171',
          background:'var(--smc-panel, #111)',
          padding:'2px 5px', borderRadius:'3px',
          whiteSpace:'nowrap',
          border:'0.5px solid rgba(248,113,113,0.3)',
          zIndex:10, pointerEvents:'none',
        }}>
          {error}
        </div>
      )}
    </div>
  );
}
